import React from "react";
import PropTypes from "prop-types";
import { Step, StepLabel, Stepper } from "@material-ui/core";

/**
 * Encabezado de pasos del formulario: el Stepper de MUI tal cual, igual que
 * PasosCrearSolicitud en la Solicitud de grado de Procesos Academicos.
 *
 * Es una copia de pocas lineas en vez de importarlo desde matriculas, para no
 * atar biblioteca al archivo de menu de otro modulo.
 */
const PasosSolicitud = ({ etiquetas, activo }) => (
  <div style={{ width: "100%" }}>
    <Stepper activeStep={activo}>
      {etiquetas.map((etiqueta) => (
        <Step key={etiqueta}>
          <StepLabel>{etiqueta}</StepLabel>
        </Step>
      ))}
    </Stepper>
  </div>
);

PasosSolicitud.propTypes = {
  etiquetas: PropTypes.arrayOf(PropTypes.string).isRequired,
  activo: PropTypes.number.isRequired,
};

export default PasosSolicitud;
